__turbopack_context__.v({
  "active": "paginationButtons-module-scss-module__D396lG__active",
  "arrowButton": "paginationButtons-module-scss-module__D396lG__arrowButton",
  "error-msg": "paginationButtons-module-scss-module__D396lG__error-msg",
  "errorIcon": "paginationButtons-module-scss-module__D396lG__errorIcon",
  "hint": "paginationButtons-module-scss-module__D396lG__hint",
  "pageButton": "paginationButtons-module-scss-module__D396lG__pageButton",
  "paginationContainer": "paginationButtons-module-scss-module__D396lG__paginationContainer",
});
